<template>
  <div id="LoginCallback">
    <div class="loading"></div>
  </div>
</template>

<script>
  import api from '@/api/calss-search'
  export default {
  name: 'LoginActiveCallback',
  created () {
    const { code, state } = this.$route.query
    if (!code || !state) {
      this.$Message.error('请先登录！')
      this.$router.push({ name: 'Login' })
    } else {
      if(!localStorage.getItem('verifyCode')){
        location.href=location.origin+'/#/records'
        return
      }
      api.activate({code,verifyCode:localStorage.getItem('verifyCode')}).then(res=>{
        this.$Message.success('开通知识库成功')
        localStorage.removeItem('verifyCode')
        location.href=location.origin+'/#/login'
        setTimeout(()=>{
          location.reload()
        },2000)
      }).catch(error=>{
        this.$Message.error(error.msg)
        if(error.code==4008||error.code==4009){
          location.href=location.origin+'/#/login'
          location.reload()
        }else{
          location.href=location.origin+'/#/login?verifyCode='+localStorage.getItem('verifyCode')
        }
      })
    }
  },
}
</script>

<style lang="scss">
#LoginCallback {
  .loading {
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    background-color: #2d8cf0;
    position: fixed;
    top: 50%;
    left: 50%;
    animation: ani-spin-bounce 1s 0s ease-in-out infinite;
  }
}

@keyframes ani-spin-bounce {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>
